import React from "react";
import * as Icons from "lucide-react";

const ServiceCard = ({ title, body, icon, onLearnMore }) => {
  const Icon = Icons[icon] || Icons.Sparkles;
  return (
    <div className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 p-7 flex flex-col h-full hover:-translate-y-1">
      <div className="w-12 h-12 rounded-xl bg-p3-cream flex items-center justify-center mb-5 group-hover:bg-p3-gold/20 transition-colors">
        <Icon size={24} className="text-p3-blue" />
      </div>
      <h3 className="font-heading font-bold text-lg text-p3-navy mb-3">{title}</h3>
      <p className="text-sm text-p3-muted leading-relaxed flex-grow">{body}</p>
      <button
        onClick={onLearnMore}
        className="mt-5 text-sm font-semibold text-p3-blue hover:text-p3-navy transition-colors inline-flex items-center gap-1 self-start"
      >
        MORE <Icons.ArrowRight size={14} />
      </button>
    </div>
  );
};

export default ServiceCard;
